import { render, staticRenderFns } from "./OtherFormStep.vue?vue&type=template&id=6cf2bdba"
import script from "./OtherFormStep.vue?vue&type=script&lang=ts"
export * from "./OtherFormStep.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports